class TokenExpiredErrorResponse {
  name: string;

  constructor() {
    this.name = "TokenExpiredErrorResponse";
  }
}

export default TokenExpiredErrorResponse;
